import {
  HsaMultiSelectConditionLeaf,
  HsaMultiSelectConditionOperator,
  HsaTextConditionLeaf,
  HsaTextConditionOperator,
} from "@redotech/redo-conversion-hsa-common/hsa-condition";
import { DeepPartial } from "@redotech/util/type";

/**
 * The leaf with its operator switched, dropping the value when the new
 * operator does not take one (the inspector hides it as uneditable).
 */
export function textLeafWithOperator(
  leaf: DeepPartial<HsaTextConditionLeaf>,
  operator: HsaTextConditionOperator,
): DeepPartial<HsaTextConditionLeaf> {
  if (
    operator === HsaTextConditionOperator.IS_EMPTY ||
    operator === HsaTextConditionOperator.IS_NOT_EMPTY
  ) {
    const { value: _value, ...rest } = leaf;
    return { ...rest, operator };
  }
  return { ...leaf, operator };
}

/** Multi-select counterpart of textLeafWithOperator. */
export function multiSelectLeafWithOperator(
  leaf: DeepPartial<HsaMultiSelectConditionLeaf>,
  operator: HsaMultiSelectConditionOperator,
): DeepPartial<HsaMultiSelectConditionLeaf> {
  if (
    operator === HsaMultiSelectConditionOperator.IS_EMPTY ||
    operator === HsaMultiSelectConditionOperator.IS_NOT_EMPTY
  ) {
    const { optionValues: _optionValues, ...rest } = leaf;
    return { ...rest, operator };
  }
  return { ...leaf, operator };
}
